import React from "react";
import { Box, Typography } from "@mui/material";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function CartToast({
    message,
    type = "success",
    visible,
}) {
    const isSuccess = type === "success";

    return (
        <Box
            sx={{
                position: "fixed",

                bottom: "26px",
                right: "26px",

                zIndex: 9999,

                transform: visible
                    ? "translateY(0) scale(1)"
                    : "translateY(18px) scale(0.96)",

                opacity: visible ? 1 : 0,

                transition:
                    "all 0.34s cubic-bezier(0.34,1.56,0.64,1)",

                background: isSuccess
                    ? "linear-gradient(135deg,#1B211A 0%, #628141 100%)"
                    : "linear-gradient(135deg,#4f0404 0%, #ce2e2e 100%)",

                border: isSuccess
                    ? "1px solid rgba(139,174,102,0.25)"
                    : "1px solid rgba(249, 29, 0, 0.25)",

                borderRadius: "20px",

                px: 2.3,
                py: 1.5,

                display: "flex",
                alignItems: "center",
                gap: 1.2,

                backdropFilter: "blur(12px)",

                boxShadow: isSuccess
                    ? "0 18px 40px rgba(98,129,65,0.22)"
                    : "0 18px 40px rgba(143, 46, 46, 0.24)",

                minWidth: "340px",
                maxWidth: "420px",

                pointerEvents: "none",
            }}
        >
            {isSuccess ? (
                <CheckCircleOutlineIcon
                    sx={{
                        color: "#8BAE66",
                        fontSize: 22,
                        flexShrink: 0,
                    }}
                />
            ) : (
                <InfoOutlinedIcon
                    sx={{
                        color: "#efcb9a",
                        fontSize: 22,
                        flexShrink: 0,
                    }}
                />
            )}

            <Typography
                sx={{
                    color: "#ffffff",

                    fontWeight: 600,

                    fontSize: "13.5px",

                    letterSpacing: "0.2px",

                    lineHeight: 1.45,
                }}
            >
                {message}
            </Typography>
        </Box>
    );
}